import { render } from "./DataInfoJurusan.vue?vue&type=template&id=51d785d0"
import script from "./DataInfoJurusan.vue?vue&type=script&lang=js"
export * from "./DataInfoJurusan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__